function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("title", null, "Menu Mobile");

var _ref3 =
/*#__PURE__*/
React.createElement("desc", null, "Created with Sketch.");

var _ref4 =
/*#__PURE__*/
React.createElement("g", {
  id: "Main",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("g", {
  id: "Mobile---Main",
  transform: "translate(-276.000000, -25.000000)",
  fill: "#ffcd4f"
}, React.createElement("g", {
  id: "Header"
}, React.createElement("path", {
  d: "M298.157817,31.8167306 L277.704183,31.8167306 C276.762579,31.8167306 276,32.5793093 276,33.5209133 C276,34.4625172 276.762579,35.2250959 277.704183,35.2250959 L298.157817,35.2250959 C299.099421,35.2250959 299.860279,34.4625172 299.860279,33.5209133 C299.860279,32.5793093 299.099421,31.8167306 298.157817,31.8167306 L298.157817,31.8167306 Z M277.705904,28.4083653 L298.159539,28.4083653 C299.101143,28.4083653 299.862,27.6457866 299.862,26.7041827 C299.862,25.7625787 299.101143,25 298.159539,25 L277.705904,25 C276.7643,25 276.001721,25.7625787 276.001721,26.7041827 C276.001721,27.6457866 276.7643,28.4083653 277.705904,28.4083653 L277.705904,28.4083653 Z M298.157817,38.6334613 L277.704183,38.6334613 C276.762579,38.6334613 276,39.39604 276,40.3376439 C276,41.2792479 276.762579,42.0418266 277.704183,42.0418266 L298.157817,42.0418266 C299.099421,42.0418266 299.860279,41.2792479 299.860279,40.3376439 C299.860279,39.39604 299.099421,38.6334613 298.157817,38.6334613 L298.157817,38.6334613 Z",
  id: "Menu-Mobile"
}))));

var SvgMenuWhite = function SvgMenuWhite(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: "24px",
    height: "18px",
    viewBox: "0 0 24 18",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? React.createElement("title", null, title) : null, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgMenuWhite, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/MenuWhite.3862628b.svg";
export { ForwardRef as ReactComponent };